import { useContextSelector } from 'use-context-selector'
import { useMemo } from 'react'
import { OfflineCache, type OfflineCacheType } from './index'

const useOfflineCache = (): OfflineCacheType => {
  const addVote = useContextSelector(OfflineCache, (state) => state.addVote)
  const votesToSync = useContextSelector(OfflineCache, (state) => state.votesToSync)
  const addGroupOperation = useContextSelector(OfflineCache, (state) => state.addGroupOperation)
  const groupOperationsToSync = useContextSelector(OfflineCache, (state) => state.groupOperationsToSync)
  return useMemo(() => ({
    addVote,
    votesToSync,
    addGroupOperation,
    groupOperationsToSync
  }), [addVote, votesToSync, addGroupOperation, groupOperationsToSync])
}

export default useOfflineCache
